var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('video', {
    staticClass: "video-js vjs-default-skin vjs-16-9 media-gallery-video",
    attrs: {
      "id": _vm.playerId,
      "controls": "",
      "preload": "auto"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }